import React from "react";
// import AppStack from "./app";
// import AuthStack from "./auth";
// import { useSelector } from "react-redux";
import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
// import Landingscreen from "../pages/Landingscreen/landingScreen";
import PageNotFound from "../pages/PageNotFound/index";

const RootStack = () => {
  // const isAuthed = useSelector((state) => state.AuthPage.authFlag);
  // let isAuthed = false;
  // const ChangePassword = React.lazy(() =>
  //   import("../pages/ChangePassword/ChangePassword.jsx")
  // );
  // const SideNavbar = React.lazy(() => import("../pages/Header/SideBar"));
  //   return (
  //     <div>
  //       {isAuthed ? (
  //         <div>
  //           <BrowserRouter>
  //             <Suspense fallback={<div></div>}>
  //               {/* <ChangePassword /> */}
  //               {/* <Landingscreen /> */}
  //               {/* <SideNavbar /> */}
  //               <PageNotFound />

  //               {/* <AppStack />  */}
  //             </Suspense>
  //           </BrowserRouter>
  //         </div>
  //       ) : (
  //         <AuthStack />
  //       )}
  //     </div>
  //   );
  return (
    <BrowserRouter>
      <Suspense fallback={<div></div>}>
        <PageNotFound />
      </Suspense>
    </BrowserRouter>
  );
};

export default RootStack;
